import {ApiService} from '../services/api.service';
import environment from '../environments/environment';
import GENERAL_DYNAMICS_ELIGIBILITY_DETAILS_SEARCH from './__mocks__/general_dynamics_eligibility_details'

import * as _ from 'lodash';
import moment from 'moment';
import {stringify} from 'qs';

export class RegistrationService {

  constructor() {
    this.apiService = new ApiService();
  }

  getAuthToken() {
    return this.apiService.go(`/auth/auth_token/`, {
      apiUrl : environment.restApiUrl,
      method : 'POST',
      headers: {
        'Accept'      : 'application/json',
        'Content-Type': 'application/json'
      },
      body   : JSON.stringify({
        auth: {
          api_key : environment.api_key,
          password: environment.password,
        }
      })
    });
  }

  async register(payload) {
    let authTokenResp = await this.getAuthToken();

    return this.apiService.go(`/api/v1/patients/`, {
      apiUrl : environment.restApiUrl,
      method : 'POST',
      headers: {
        'Authorization': authTokenResp.parsed.data.jwt,
        'Content-Type' : 'application/json'
      },
      body   : JSON.stringify(payload)
    });
  }

  affiliationList(query, withId) {
    var criteria = withId != undefined ? "id" : "q";
    query = encodeURIComponent(query);
    return this.apiService.go(`/register/affiliations_list?&${criteria}=${query}`);
  }

  affiliationEligibilityDetailsSearch(name) {
    // -- Mock --
    // return {
    //   parsed: {
    //     data: GENERAL_DYNAMICS_ELIGIBILITY_DETAILS_SEARCH
    //   }
    // }

    return this.apiService.go(`/register/affiliation_eligibility_details_search?name=${name}`);
  }

  affiliationCoverages(zip) {
    return this.apiService.go(`/register/affiliation_coverages?zip=${zip}`);
  }

  validZip(zip) {
    return this.apiService.go(`/register/valid_zip?zip=${zip}`);
  }

  isUsernameAvailable(value) {
    return this.apiService.go(`/register/check_username_availability?username=${value}`);
  }

  async checkEligibility(patient) {
    let authTokenResp = await this.getAuthToken();
    return this.apiService.go(`/api/v1/eligibility_checks/create_simple/`, {
      apiUrl : environment.restApiUrl,
      method : 'POST',
      headers: {
        'Authorization': authTokenResp.parsed.data.jwt,
        'Content-Type' : 'application/json'
      },
      body   : JSON.stringify({ eligibility_check: patient })
    });
  }

  checkEligibilityStatus(token) {
    return this.apiService.go(`/register/check_eligibility_status?id=${token}`);
  }

  getPatientCreateObject(patientDataInState) {
    let patient = {};
    patient['affiliation_id'] = _.get(patientDataInState, 'eligibilityBusinessUnitData.affiliation_id', false) || patientDataInState.affiliationId || 96;
    patient['first_name'] = patientDataInState.firstName;
    patient['last_name'] = patientDataInState.lastName;
    patient['email'] = patientDataInState.email;
    patient['username'] = patientDataInState.username;
    patient['password'] = patientDataInState.password;
    patient['password_confirmation'] = patientDataInState.confirmPassword;
    patient['phone'] = patientDataInState.phone + ''; // it has to be a string
    patient['zip'] = patientDataInState.zip + ''; // string
    patient['birthdate'] = moment(new Date(patientDataInState.dob)).format('MM/DD/YYYY');
    patient['gender'] = patientDataInState.gender;
    patient['dependent'] = patientDataInState.isDependent ? true : false;

    if (!_.isUndefined(patientDataInState['eligibility_check_token'])) {
      patient['eligibility_check_token'] = patientDataInState['eligibility_check_token'];
    }

    if (!_.isUndefined(patientDataInState['memberID'])) {
      patient['member_id'] = patientDataInState.memberID;
    }

    // remove leading and trailing spaces
    _.each(patient, (value, key) => {
      patient[key] = _.isString(patient[key]) ? _.trim(patient[key]) : patient[key];
    });

    return patient;
  }

  getPatientEligibilityObject(patientDataInState) {
    let patient = {};
    patient['affiliation_id'] = _.get(patientDataInState, 'eligibilityBusinessUnitData.affiliation_id', false) || 96; // 96 is for DTC, 270 is for General Dynamics
    patient['first_name'] = patientDataInState.firstName;
    patient['last_name'] = patientDataInState.lastName;
    patient['zip'] = patientDataInState.zip + ''; // string
    patient['birthdate'] = moment(new Date(patientDataInState.dob)).format('YYYY-MM-DD');
    patient['gender'] = patientDataInState.gender;
    patient['dependent'] = patientDataInState.isDependent ? true : false;
    patient['member_id'] = patientDataInState.memberID270;

    if (_.get(patientDataInState, 'eligibilityBusinessUnit.id', false)) {
      patient['business_unit_id'] = patientDataInState.eligibilityBusinessUnit.id;
      patient['insurance_payer_id'] = patientDataInState.eligibilityInsurancePlan;
    }

    if (patientDataInState.isDependent) {
      patient['primary_first_name'] = patientDataInState.primaryFirstName;
      patient['primary_last_name'] = patientDataInState.primaryLastName;
      patient['primary_birthdate'] = moment(new Date(patientDataInState.primaryDOB)).format('YYYY-MM-DD');
      patient['primary_gender'] = patientDataInState.primaryGender;
      patient['primary_member_id'] = patientDataInState.primaryMemberID270;
      patient['relationship'] = patientDataInState.relationship;
    }

    // remove leading and trailing spaces
    _.each(patient, (value, key) => {
      patient[key] = _.isString(patient[key]) ? _.trim(patient[key]) : patient[key];
    });

    return patient;
  }

  parseErrors(errorMessage) {
    var em = JSON.stringify(errorMessage).replace(/[^\w\s:,]/gi, '').replace(/[:]/gi, ': ').replace(/[,]/gi, ', ');
    return em;
  }

  parseMemberInfo(memberInfo) {
    if (memberInfo != "") {
      return JSON.parse(atob(memberInfo));
    } else {
      return null;
    }
  }

  checkCanSubmit(stateToValidate, stateToCheckForNullity, requiredFields) {
    let errorCount = 0;

    // check errors in the state
    if (_.size(stateToValidate)) {
      _.each(stateToValidate, (data) => {
        if (!data.valid)
          errorCount++;
      });
    }

    _.each(requiredFields, (fieldName) => {
      let value = _.get(stateToCheckForNullity, fieldName, '');
      if (value === '' || value === null || _.isUndefined(value)) {
        errorCount++;
      }
    });

    return errorCount ? false : true;
  }

  login(signupRespData) {
    // let loginUrl = LOGIN_URL + '/login?flash=Account%20Activated';
    // window.location.href = loginUrl;
    let sessionData = {
      status_token: signupRespData.token[1][1],
      idp_id      : signupRespData.token[1][0],
      user_id     : signupRespData.patient.id,
    };
    sessionData.url = `/set_cookie?user_id=${sessionData.user_id}&idp_id=${sessionData.idp_id}&status_token=${sessionData.status_token}`;

    return this.apiService.go(sessionData.url);

    // @TODO: Trying to get the authenticity_token to work
    //
    // return this.apiService.go(`/register/set_session_and_redirect?authenticity_token=${encodeURIComponent(FORM_AUTHENTICITY_TOKEN)}`, {
    //   method : 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body   : JSON.stringify(signupRespData)
    // })
    //   .then((resp) => {
    //     console.log(resp.parsed);
    //   });
  }

  async sendUtmReferral(patient_id) {
    let authTokenResp = await this.getAuthToken();
    let urlSearch = this.getUrlSearchToObj();
    if (_.size(urlSearch.utm_campaign) || _.size(urlSearch.utm_medium) || _.size(urlSearch.utm_source) || _.size(urlSearch.utm_term) || _.size(urlSearch.utm_content)) {
      return this.apiService.go(`/api/v1/utm_referrals/`, {
        apiUrl : environment.restApiUrl,
        method : 'POST',
        headers: {
          'Authorization': authTokenResp.parsed.data.jwt,
          'Content-Type' : 'application/json'
        },
        body   : JSON.stringify({
          utm_referral: {
            user_id     : patient_id,
            utm_campaign: urlSearch.utm_campaign,
            utm_medium  : urlSearch.utm_medium,
            utm_source  : urlSearch.utm_source,
            utm_term    : urlSearch.utm_term,
            utm_content : urlSearch.utm_content
          }
        })
      });
    }
    return Promise.resolve();
  }

  /**
   * Returns the current window.location.search params.
   * It's in a separate function because we need to mock it in our tests
   * since `window.location` can't be modified from the test file
   * @returns {object|*}
   */
  getUrlSearchToObj(searchStr = window.location.search) {
    let qs = require('qs');
    return qs.parse(`${_.trimStart(searchStr, '?')}`);
  }

}



// WEBPACK FOOTER //
// ./registration-react/registration.service.js